import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

function Footer(props) {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {/* Navigation + disclaimer column */}
        <div>
          <div className={styles.navGroup}>
            <h2>Pages</h2>

            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <button className={styles.navButton}>Application</button>
            </Link>

            <Link to="/research" onClick={() => window.scrollTo(0, 0)}>
              <button className={styles.navButton}>Research</button>
            </Link>

            <Link to="/reserve" onClick={() => window.scrollTo(0, 0)}>
              <button className={styles.navButton}>Reserve</button>
            </Link>
          </div>
          <br></br>

          {props?.disclaimer && (
            <div className={styles.disclaimer}>
              <h2>Disclaimer</h2>
              <p>
                Any use of the JUUL device is solely to depict the compatibility
                of Qwytt and does not imply affiliation. All JUUL trademarks and
                trade dress are owned by JUUL Labs, Inc., and are the exclusive
                property of JUUL Labs, Inc.
              </p>
            </div>
          )}
        </div>

        {/* Address / contact column */}
        <div className={styles.address}>
          <p>
            Qwytt Inc.<br />
            651 N. Broad Street Suite 201<br />
            Middletown, DE 19709<br />
            USA
          </p>
          <p>contact@qwytt.ai</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
